import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { navLinks, company } from '../mock';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 ${
        scrolled ? 'bg-ivory/95 backdrop-blur-md shadow-[0_1px_0_0_rgba(10,31,61,0.06)]' : 'bg-transparent'
      }`}
      style={{ transition: 'background-color 400ms ease, box-shadow 400ms ease' }}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex items-center justify-between h-20 lg:h-24">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-3 group" aria-label="KMH & Associates - Home">
          <img
            src={company.logo}
            alt="KMH & Associates - Company Secretaries"
            className="h-12 lg:h-14 w-auto object-contain"
          />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif-display text-lg text-ink tracking-wide">KMH &amp; Associates</span>
            <span className="font-mono-label text-[0.6rem] text-gold">Company Secretaries · Est. {company.founded}</span>
          </div>
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="link-underline font-sans-body text-sm text-ink-soft hover:text-ink"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden lg:flex items-center gap-6">
          <a href={`tel:${company.phone}`} className="flex items-center gap-2 text-ink-soft hover:text-gold-dark">
            <Phone className="w-4 h-4 text-gold" />
            <span className="font-sans-body text-sm font-medium">{company.phone}</span>
          </a>
          <a
            href="#contact"
            className="btn-premium relative inline-flex items-center gap-2 border border-ink text-ink hover:text-ivory px-6 py-3 font-mono-label"
          >
            Get in Touch
          </a>
        </div>

        {/* Mobile */}
        <button
          className="lg:hidden p-2 text-ink"
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-ivory border-t border-line">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-sans-body text-ink-soft"
              >
                {l.label}
              </a>
            ))}
            <a href="#contact" className="mt-2 inline-flex items-center justify-center border border-ink text-ink px-6 py-3 font-mono-label">
              Get in Touch
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
